
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { themeName } from "@/core/helpers/documentation";

export default defineComponent({
  name: "overview",
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Overview");
    });

    return {
      themeName
    };
  }
});
